import Button from '@mui/material/Button';
import { lighten } from 'polished';
import { shapeOverlay, commonStyle } from 'components/common/CommonStyled';

export const StyledButton = commonStyle(
  Button,
  ({ theme, btnType, isCircle, hasAnimation, hasActiveOverlay, size, gap }) => `
    gap: ${gap !== undefined ? `${theme.space[gap]}px` : '12px'};

    ${
      btnType === 'black'
        ? `background-color: ${theme.colors.blackColor}; 
            color: ${theme.colors.whiteColor} !important;`
        : btnType === 'white'
        ? `
            background-color:  ${lighten(0.1, theme.colors.primaryColor)};;
            box-shadow: ${theme.shadows[25]};
            `
        : ''
    }

    ${
      isCircle
        ? `
            border-radius: ${theme.radii.high};
            height: 3em;
            width: 3em;
            min-width: 3em;
            font-size: ${
              size === 'small' ? theme.fontSizes[0] : theme.fontSizes[3]
            };
            padding: 0;
          `
        : ''
    }

    ${hasActiveOverlay ? shapeOverlay({ toScale: 1.4, noAnime: true }) : ''}
    ${hasAnimation ? shapeOverlay({ toScale: 1.6 }) : ''}
`,
);
